import styled from "styled-components";

export const BalanceCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1);
  border-radius: 12px;
  padding: 24px;
  width: 520px;
  margin-bottom: 30px;
`;

export const BalanceCardLabel = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 590;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
  padding-bottom: 8px;
`;

export const BalanceLabel = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #101828;
`;

export const CardSection = styled.div`
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
  gap: 20px;

  @media (max-width: 1350px) {
    justify-content: center;
  }
`;

export const StyledCard = styled.div`
  width: 290px;
  min-width: 290px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1),
    0px 1px 2px rgba(16, 24, 40, 0.06);
  border-radius: 12px;
`;

export const CardHeader = styled.div`
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  height: 23px;
  width: 100%;
`;

export const CardLabel = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 590;
  font-size: 20px;
  line-height: 26px;
  color: #101828;
  padding-top: 18px;
  padding-bottom: 20px;
`;

export const CardBtn = styled.div`
  width: 142px;
  height: 40px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ViewTransactionText = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-decoration-line: underline;
  color: #000000;
  position: absolute;
  bottom: 50px;
  left: 86px;
  cursor: pointer;

  @media (max-width: 1350px) {
    position: initial;
    padding-top: 30px;
  }

  @media (max-height: 750px) {
    position: initial;
    padding-top: 30px;
  }
`;
